export default "__VITE_ASSET__DpBwseIK__"